<template>
  <div class="companyBox">
    <navigation></navigation>
    <div class="homeBG">
    </div>
    <div class="contenter">
      <div class="customerLogo">
        <div class="logoText">
          我们的客户
        </div>
        <div class="logoBox">
          <div class="logolist">
            <img src="../img/logo1.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo2.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo3.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo4.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo9.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo6.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo7.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo8.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo5.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo10.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo11.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo12.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo13.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo14.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo20.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo16.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo17.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo18.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo19.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo15.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo21.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo22.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo23.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo24.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo25.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo26.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo27.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo28.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img style="object-fit: cover;" src="../img/logo29.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo30.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo31.jpg" alt="客户Logo">
          </div>
          <div class="logolist">
            <img src="../img/logo32.jpg" alt="客户Logo">
          </div>
        </div>
      </div>
    </div>

    <!-- 地图容器 - 已修改为响应式 -->
    <div id="dituContent" class="map-container"></div>

    <dibu></dibu>
  </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from './dibu.vue';

export default {
  name: 'CompanyProfile',
  components: {
    navigation,
    dibu
  },
  mounted() {
    this.initmap();
    
    // 监听窗口大小变化，重新调整地图
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    initmap() {
      let markerPosition = new TMap.LatLng(31.846889,118.575545);
      
      // 获取地图容器的实际尺寸
      const container = document.getElementById('dituContent');
      const containerWidth = container.offsetWidth;
      
      this.tMap = new TMap.Map('dituContent', {
        zoom: 15,
        center: markerPosition,
        pitch: 0, // 俯仰角（3D效果）
        rotation: 0, // 地图旋转角度
        // 根据容器宽度动态调整一些参数
        ...(containerWidth < 768 && {
          // 移动端可以设置一些特殊参数
          enableAutoResize: true
        })
      });
      
      // 创建标记点样式
      const markerStyle = new TMap.MarkerStyle({
        width: 25,
        height: 35,
        anchor: { x: 12.5, y: 35 }, // 精确锚点（底部中心）
        src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png',
        scale: 1
      })
      
      // 创建标记点图层
      this.markerLayer = new TMap.MultiMarker({
        map: this.tMap,
        styles: { default: markerStyle },
        geometries: [{
          id: 'company-marker',
          position: markerPosition, // 关键点：使用指定坐标
          styleId: 'default',
          properties: {
            title: '公司位置',
            address: '坐标：31.846889,118.575545'
          }
        }]
      })
      
      // 添加地图缩放事件监听器（确保标记点位置不变）
      this.tMap.on('zoom', () => {
        this.markerLayer.updateGeometries([{
          id: 'company-marker',
          position: markerPosition // 强制保持原始坐标
        }])
      })
      
      // 信息窗口
      this.infoWindow = new TMap.InfoWindow({
        map: this.tMap,
        position: markerPosition,
        content: `
                    <div style="padding: 10px; box-sizing: border-box;  ">
                        <h4 style="margin:0 0 5px 0;">南京际华三五二一环保科技有限公司</h4>
                        <p style="margin:0;">江苏省南京市江宁滨江经济开发区飞鹰路36号</p>
                    </div>
                `,
        visible: false
      })

      // 点击标记点显示信息窗口
      this.markerLayer.on('click', (evt) => {
        if (evt.geometry.id === 'company-marker') {
          this.infoWindow.open()
        }
      })
    },
    
    // 处理窗口大小变化
    handleResize() {
      if (this.tMap) {
        // 延迟执行，确保DOM更新完成
        setTimeout(() => {
          this.tMap.resize();
        }, 100);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.companyBox {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
   position: relative;

  .homeBG {
    width: 100%;
    height: 800px;
    background-image: url('../img/zszqbanner.jpg');
    background-size: 100% 100%;

    /* 平板适配 */
    @media (max-width: 1024px) {
      height: 600px;
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
      height: 500px;
      background-size: cover;
      background-position: center;
    }

    /* 小手机适配 */
    @media (max-width: 480px) {
      height: 400px;
    }

    /* 超小手机适配 */
    @media (max-width: 360px) {
      height: 350px;
    }
  }

  .contenter {
    width: 100%;
    max-width: 1830px;
    margin: 0 auto 60px;
    // padding: 0 20px;
  }

  .customerLogo {
    width: 100%;
    margin-top: 20px;
    padding: 20px;
    box-sizing: border-box;
  }

  .logoText {
    width: 100%;
    text-align: center;
    font-size: 40px;
    font-weight: 500;
    margin-bottom: 30px;

    /* 平板适配 */
    @media (max-width: 1024px) {
      font-size: 36px;
      padding: 0px;
      box-sizing: border-box;
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
      font-size: 32px;
      margin-bottom: 20px;
      padding: 0px;
      box-sizing: border-box;
    }

    /* 小手机适配 */
    @media (max-width: 480px) {
      font-size: 28px;
      margin-bottom: 15px;
    }
  }

  .customerLogo .logoBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    padding-top: 20px;
    box-sizing: border-box;

    /* 移动端适配 */
    @media (max-width: 768px) {
      gap: 15px;
    }
  }

  .logolist {
    width: 200px;
    height: 150px;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    /* 平板适配 */
    @media (max-width: 1024px) {
      width: 180px;
      height: 130px;
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
      width: 45%;
      max-width: 160px;
      height: 120px;
      padding: 10px;
    }

    /* 小手机适配 */
    @media (max-width: 480px) {
      width: 45%;
      max-width: 140px;
      height: 100px;
      padding: 8px;
    }

    /* 超小手机适配 */
    @media (max-width: 360px) {
      width: 45%;
      max-width: 120px;
      height: 90px;
      padding: 6px;
    }
  }

  .logolist:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }

  .logolist img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    /* 统一使用contain，保持图片比例完整显示 */
    border-radius: 8px;
  }
}

/* 地图容器 - 已优化移动端适配 */
.map-container {
  width: 100%;
  max-width: 1400px;
  height: 600px;
  margin: 0 auto 40px;
  padding: 0 20px;
  box-sizing: border-box;

  /* 平板适配 */
  @media (max-width: 1024px) {
    height: 350px;
    padding: 0 15px;
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    height: 300px;
    padding: 0 10px;
    margin-bottom: 30px;
  }

  /* 小手机适配 */
  @media (max-width: 480px) {
    height: 250px;
    padding: 0 10px;
    margin-bottom: 25px;
  }

  /* 超小手机适配 */
  @media (max-width: 360px) {
    height: 200px;
    padding: 0 5px;
    margin-bottom: 20px;
  }
}
</style>